import { useParallaxTransform } from '@/hooks/useParallax';

export default function CTA() {
  const ctaRef = useParallaxTransform(0.06);

  return (
    <section className="py-24 sm:py-28 lg:py-16 relative overflow-hidden">
      <div ref={ctaRef} className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 will-change-transform animate-fade-in-up delay-100">
        <h2
          className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#00A8B5] mb-6 lg:mb-6 animate-fade-in-up delay-300"
        >
          Réservez votre remorque bar pour votre prochain événement
        </h2>
        <p className="text-xl text-gray-700 mb-8 lg:mb-8 max-w-2xl mx-auto leading-relaxed animate-fade-in-up delay-400">
          Anticipez votre réservation pour garantir votre date
        </p>
        <a
          href="#devis"
          className="inline-block bg-[#00A8B5] hover:bg-[#008f9b] text-black font-semibold px-12 py-4 rounded-md transition-all duration-300 whitespace-nowrap text-lg cursor-pointer animate-fade-in-up delay-500"
        >
          Réserver ma date
        </a>
      </div>

      {/* Phrase d'accroche pleine largeur */}
      <div className="w-full mt-20 sm:mt-24 lg:mt-14 text-center animate-fade-in-up delay-600 px-4">
        <p
          className="font-extrabold tracking-wide text-[#00A8B5] text-center"
          style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(2.6rem, 5.5vw, 6rem)' }}
        >
          Branchez, Servez. Santé !
        </p>
      </div>
    </section>
  );
}